import { render } from "./ksbvip.vue?vue&type=template&id=4e20408c&scoped=true"
import script from "./ksbvip.vue?vue&type=script&lang=js"
export * from "./ksbvip.vue?vue&type=script&lang=js"

import "./ksbvip.vue?vue&type=style&index=0&id=4e20408c&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e20408c"]])

export default __exports__